import React from 'react';

import * as S              from './footer.module.scss';
import { FooterLinkGroup } from './footer-links-group';
import { useGlobalCtx }    from '../../../context/ctx-hook';

const Footer = () => {
  const {state}             = useGlobalCtx();
  const links               = state.footer;
  const [isOpen, setIsOpen] = React.useState(false);
  const handleNavClick      = React.useCallback(() => setIsOpen(!isOpen), [isOpen]);

  return (
    <footer id="footer" className={S.footerMain}>
      <div className={S.footerMenuContainer}>
        {/* Link rows */}
        <div className={S.footerMenuContainerRow}>
          <div className={S.col_sm_3}>
            <FooterLinkGroup title={'Personal Finance Software'} links={links['Personal Finance Software']} cls={S.linksList}/>
            <FooterLinkGroup title={'Quicken Solutions'} links={links['Quicken Solutions']} cls={S.linksList}/>
          </div>
          <div className={S.col_sm_3}>
            <FooterLinkGroup title={'Quicken Benefits'} links={links['Quicken Benefits']} cls={S.linksList}/>
            <FooterLinkGroup title={'What’s New in Quicken'} links={links['What’s New in Quicken']} cls={S.linksList}/>
            <FooterLinkGroup title={'Quicken Community'} links={links['Quicken Community']} cls={S.linksList}/>
            <FooterLinkGroup title={'About Us'} links={links['About Us']} cls={S.linksList}/>
          </div>
          <div className={S.col_sm_3}>
            <FooterLinkGroup title={'Help and Support'} links={links['Help and Support']} cls={S.linksList}/>
            <FooterLinkGroup title={'Sign In'} links={links['Sign In']} cls={S.linksList}/>
            <FooterLinkGroup title={'Tips and Tools'} links={links['Tips and Tools']} cls={S.linksList}/>
          </div>
          <div className={S.col_sm_3}>
            <FooterLinkGroup title={'Corporate Programs'} links={links['Corporate Programs']} cls={S.linksList}/>
            <FooterLinkGroup title={'Quicken Canada'} links={links['Quicken Canada']} cls={S.linksList}/>
          </div>
        </div>
        {/* footnotes */}
        <div className={S.footnotes}>
          <button onClick={handleNavClick}>* Footnotes and disclaimers</button>
          {isOpen && (
            <div className="region region-footnotes">
              <div id="block-block-1" className="block block-block">
                <div className="content">
                  <ul className={S.footnotesContent}>
                    <li><strong>Monitoring alerts, data downloads, and feature updates are available
                      through the end of your membership term.</strong> Online services require
                      internet access. Third-party terms and additional fees may apply. Phone support,
                      online features, and other services vary and are subject to change. 14,500+
                      participating financial institutions as of October 1, 2018.
                    </li>
                    <li><strong>Standard message and data rates may apply for sync, e-mail and text
                      alerts.</strong> Visit <a
                      href="https://www.quicken.com/go/apps">https://www.quicken.com/go/apps</a>&nbsp;for
                      details. Quicken App is compatible with iPad, iPhone, iPod Touch, Android phones
                      and tablets. Not all Quicken desktop features are available in the App. The App
                      is a companion app and will work only with Quicken 2015 and above desktop
                      products.
                    </li>
                    <li className="pricing-yearlyPlus3-hide pricing-monthlyPlus3-hide"><strong>Purchase
                      entitles you to Quicken for 1 or 2 years (depending upon length of membership
                      purchased), starting at purchase.</strong> Full payment is charged to your card
                      immediately. At the end of the membership period, membership will automatically
                      renew every year and you will be charged the then-current price (prices subject
                      to change). You may cancel before renewal date. For full details, consult the
                      Quicken Membership Agreement. You can manage your subscription at your My
                      Account page.
                    </li>
                    <li className="pricing-yearlyPlus3-show pricing-monthlyPlus3-show">
                      <strong>
                        Purchase entitles you to Quicken for 1 or 2 years (depending upon length of
                        membership purchased), starting at purchase, plus 3 free bonus months, if applicable.
                      </strong>
                      Full payment is charged to your card immediately. At the end of the membership period
                      (including 3 free bonus months if applicable), membership will automatically renew
                      every year for a period of 1 year and you will be charged the then-current price
                      (prices subject to change). You may cancel before renewal date. For full details, consult
                      the Quicken Membership Agreement. You can manage your subscription at your My Account page.
                    </li>
                    <li>
                      <strong>If you are redeeming the free Quicken Starter product</strong>
                      through the purchase of TurboTax, and you are currently in an active Quicken subscription
                      and not within 6 months of your renewal date, you will have to return to this page within
                      6 months of renewal in order to redeem. Additionally,
                      <strong>
                        note that if you are currently subscribed to Quicken Deluxe, Quicken Premier or Quicken
                        Home &amp; Business
                      </strong>,
                      by redeeming the free Quicken Starter product, you will lose some of the
                      features that are associated with your current higher-tiered product.
                    </li>
                    <li>
                      <strong>
                        Quicken for Windows imports data from Quicken for Windows 2010 or newer,
                        Microsoft Money 2008 and 2009 (for Deluxe and higher). Quicken for Mac imports
                        data from Quicken for Windows 2010 or newer, Quicken for Mac 2015 or newer, Quicken
                        for Mac 2007, Quicken Essentials for Mac, Banktivity.
                      </strong>
                    </li>
                    <li>
                      <strong>
                        <strong>30-day money back guarantee:</strong>
                        If you’re not satisfied, return this product to Quicken within 30 days of purchase with
                        your dated receipt for a full refund of the purchase price less shipping and handling fees.
                        See <a href="https://www.quicken.com/30dayguarantee">https://www.quicken.com/30dayguarantee</a>
                        for full details and instructions.
                      </strong>
                    </li>
                    <li>
                      <strong>
                        <strong>
                          Quicken for Mac software and the Quicken App are not designed to function outside the U.S.
                        </strong>
                      </strong>
                    </li>
                    <li>
                      <strong>
                        <strong>
                          The VantageScore provided under the offer described here uses a proprietary credit
                          scoring model designed by VantageScore Solutions, LLC.
                        </strong>
                        There are numerous other credit scores and models in the marketplace, including different
                        VantageScores. Please keep in mind third parties may use a different credit score when
                        evaluating your creditworthiness. Also, third parties will take into consideration items other
                        than your credit score or information found in your credit file, such as your income.
                      </strong>
                    </li>
                    <li>
                      <strong>
                        <strong>VantageScore®</strong>,
                        <strong>Equifax®</strong>,
                        <strong>Experian®</strong> and
                        <strong>TransUnion®</strong> are registered trademarks of their respective owners.
                      </strong>
                    </li>
                    <li>
                      <strong>
                        All 2018 and newer versions of Quicken entitle users to 5GB of free Dropbox storage
                        while subscription is in effect.
                      </strong>
                    </li>
                    <li>
                      <strong>
                        <strong>EQUIFAX</strong>
                        is a registered trademark of Equifax Inc. The other Equifax marks used herein are
                        trademarks of Equifax Inc. Other product and company names mentioned herein are property
                        of their respective owners.
                      </strong>
                    </li>
                    <li>
                      <strong>
                        Portfolio tracking included with Quicken Premier and Quicken Home &amp; Business on Windows
                      </strong>
                    </li>
                    <li>
                      <strong>Payment links are only available for Quicken Home &amp; Business.</strong>
                    </li>
                    <li>
                      <strong>
                        <strong>Illustrations © Adam Simpson.</strong>
                        All rights reserved.
                      </strong>
                    </li>
                    <li>
                      <strong>
                        <strong>© 2021 Quicken Inc.</strong>
                        All rights reserved. Quicken is a registered trademark of Intuit Inc., used under license.
                      </strong>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Footer Bottom */}
        <div className={S.footerBottom}>
          <FooterLinkGroup links={links['Sitemap']} cls={S.inlineLinksList}/>
          <small className="copyright">
            © 2021 Quicken Inc. All rights reserved. Quicken is a registered trademark of Intuit Inc.,
            used under license.
          </small>
          <small>
            iPhone, iPod, iPad Touch are trademarks of Apple Inc., registered in the U.S. and other
            countries. Android is a trademark of Google Inc.
          </small>
          <small>
            Dropbox, PayPal, Yelp, and other parties’ marks are trademarks of their respective companies.
          </small>
          <small>
            Terms, conditions, features, availability, pricing, fees, service and support options subject
            change without notice.
          </small>
          <small>
            Corporate Headquarters: 3760 Haven Avenue, Menlo Park, CA 94025
          </small>
          <small className="ccpa-wrapper ccpa-wrapper-processed">
            <a href={process.env.REACT_APP_STORE_URL + '/privacy/us/ccpa/opt-out'}>Do not sell my information</a>
          </small>
        </div>
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';

export { Footer };
